<template>
  <v-checkbox 
    class="btn-total-load"
    :class="className"
    :disabled="disabled"
    :label="text"
    :false-value="0"
    :true-value="1"
    v-model="filters.total_load" ></v-checkbox>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      deafult: false,
    },
    filters: {
      type: Object,
      default: () => {},
    },
    text: {
      type: String,
      default: 'Cartera Total',
    },
    className: {
      type: String,
      default: '',
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/panelV2/ActualButton.vue